import {casa, terreni, casa_terreno, beni_culturali, mutuo_surroga, donazioni, permute, conferimenti, servitu, divisioni, cancellazione_ipoteca, costituzione_societa, cessione_quote, verbale_assemblea, cessione_aziende, affitto_azienda, procura, separazione_beni, fondo_con_trasferimento, accettazione_eredita, accettazione_tacita, atti_mortis_causa, procedure, estratti, separazione, fondo_patrimoniale, atti_dichiarativi, altri_trasferimenti, trasferimenti_coniuge, atti_vari, scissioni_fusioni, certificazioni, enti_terzo_settore, vari } from '../../svg/svgs.js'
export default {
  "Immobiliare": {
    "Compravendita Fabbricati": {
      "icon": casa,
      "visible": true,
      "dati": {
        "1": {
          "num": "1.1.10",
          "title": "Fabbricati con prezzo valore",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "sottocategoria": "sottocategoriaCasa",
          "form": "fabbricatiConPrezzoValore",
          "action": "fabbricati_con_prezzo_valore",
          "url": "fabbricati_con_prezzo_valore",
          "keywords": [
            "fabbricati",
            "prezzo",
            "prezzo valore",
            "compravendita",
            "fabbricati con prezzo valore",
            "fabbricati prezzo valore",
            "fabbricati",
            "immobiliare",
            "prima casa",
            "seconda casa",
            "casa",
            "privati"
          ],
          "search": false
        },
        "2": {
          "num": "1.1.20",
          "title": "Fabbricati senza prezzo valore",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "sottocategoria": "sottocategoriaCasa",
          "form": "fabbricatiSenzaPrezzoValore",
          "action": "fabbricati_senza_prezzo_valore",
          "url": "fabbricati_senza_prezzo_valore",
          "keywords": [
            "fabbricati",
            "prezzo",
            "compravendita",
            "fabbricati senza prezzo valore",
            "fabbricati prezzo valore",
            "privati",
            "immobiliare",
            "accatastato",
            "non accatastato",
            "prima casa",
            "seconda casa",
            "casa"
          ],
          "search": false
        },
        "3": {
          "num": "1.1.30",
          "title": "Fabbricati con I.V.A.",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "sottocategoria": "sottocategoriaCasa",
          "form": "fabbricatiConIva",
          "action": "fabbricati_con_iva",
          "url": "fabbricati_con_iva",
          "keywords": [
            "fabbricati",
            "fabbricati con I.V.A.",
            "fabbricati con iva",
            "iva",
            "compravendita",
            "impresa",
            "immobiliare",
            "prima casa",
            "seconda casa",
            "casa"
          ],
          "search": false
        },
        "4": {
          "num": "1.1.40",
          "title": "Fabbricati da soggetti I.V.A.",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "sottocategoria": "sottocategoriaCasa",
          "form": "fabbricatiDaSoggettiIva",
          "action": "fabbricati_da_soggetti_iva",
          "url": "fabbricati_da_soggetti_iva",
          "keywords": [
            "fabbricati",
            "fabbricati da soggetti I.V.A.",
            "fabbricati da soggetti iva",
            "iva",
            "soggetti",
            "immobiliare"
          ],
          "search": false
        }
      }
    },
    "Compravendita Terreni": {
      "icon": terreni,
      "visible": true,
      "dati": {
        "1": {
          "num": "1.2.10",
          "title": "Agricolo / Edificabile - da privato",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "acquistoTerrenoDaPrivatoAgricoloEdificabile",
          "sottocategoria": "sottocategoriaTerreni",
          "action": "acquisto_terreno_agricolo_edificabile_da_privato",
          "url": "acquisto_terreno_agricolo_edificabile_da_privato",
          "keywords": [
            "compravendita terreni",
            "compravendita terreno",
            "compravendita",
            "terreno",
            "agricolo edificabile da privato",
            "terreno agricolo",
            "terreno edificabile",
            "agricolo",
            "edificabile",
            "da privato",
            "da privati",
            "privati",
            "privato"
          ],
          "search": false
        },
        "2": {
          "num": "1.2.20",
          "title": "Agricolo / Edificabile - da impresa",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "acquistoTerrenoDaImpresaAgricoloEdificabile",
          "sottocategoria": "sottocategoriaTerreni",
          "action": "acquisto_terreno_agricolo_edificabile_da_impresa",
          "url": "acquisto_terreno_agricolo_edificabile_da_impresa",
          "keywords": [
            "compravendita terreni",
            "compravendita terreno",
            "compravendita",
            "terreno",
            "agricolo edificabile da impresa",
            "terreno agricolo",
            "terreno edificabile",
            "agricolo",
            "edificabile",
            "da impresa",
            "da imprese",
            "impresa"
          ],
          "search": false
        },
        "3": {
          "num": "1.2.30",
          "title": "Agricolo - agevolato",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "AcquistiAgevolati",
          "sottocategoria": "sottocategoriaTerreni",
          "action": "acquisti_agevolati",
          "url": "acquisti_agevolati",
          "keywords": [
            "compravendita terreni",
            "compravendita terreno",
            "compravendita",
            "terreno",
            "agricolo agevolato",
            "terreno agricolo",
            "agricolo",
            "agevolaro",
            "ppc",
            "piccola proprietà contadina",
            "proprietà contadina",
            "iap",
            "territori montani"
          ],
          "search": false
        }
      }
    },
    "Compravendita Casa e Terreno": {
      "icon": casa_terreno,
      "visible": true,
      "dati": {
        "1": {
          "num": "1.3.10",
          "title": "Fabbricati e Terreni con prezzo valore",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "primaSecondaCasaTerrenoTraPrivati",
          "sottocategoria": "sottocategoriaCasaTerreno",
          "action": "fabbricati_terreni_con_prezzo_valore",
          "url": ["fabbricati_terreni_con_prezzo_valore","prima_seconda_casa_terreno_tra_privati"],
          "keywords": [
            "compravendita casa terreno",
            "compravendita di casa e terreno",
            "compravendita",
            "casa e terreno",
            "casa",
            "terreno",
            "prima casa",
            "seconda casa",
            "prima seconda casa terreno tra privati",
            "terreno",
            "tra privati",
            "privati",
            "casa + terreno"
          ],
          "search": false
        },
        "2": {
          "num": "1.3.20",
          "title": "Fabbricati e Terreni senza prezzo valore",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "primaSecondaCasaTerrenoTraPrivatiImmobileNonAccatastato",
          "sottocategoria": "sottocategoriaCasaTerreno",
          "action": "fabbricati_terreni_senza_prezzo_valore",
          "url": ["fabbricati_terreni_senza_prezzo_valore","prima_seconda_casa_terreno_tra_privati_immobile_non_accatastato"],
          "keywords": [
            "compravendita casa terreno",
            "compravendita di casa e terreno",
            "compravendita",
            "casa e terreno",
            "casa",
            "terreno",
            "prima casa",
            "seconda casa",
            "prima seconda casa terreno tra privati immobile non accatastato",
            "terreno",
            "tra privati",
            "privati",
            "casa + terreno",
            "non accatastato",
            "accatastato",
            "immobile"
          ],
          "search": false
        }
      }
    },
    "Compravendita Beni Culturali": {
      "icon": beni_culturali,
      "visible": true,
      "dati": {
        "1": {
          "num": "1.4.10",
          "title": "Beni culturali - I Atto - Sottoposto a condizione",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "comprevenditaDiBeniCulturaliPrimoAttoSottopostoCondizione",
          "sottocategoria": "sottocategoriaBeniCulturali",
          "action": "compravendita_beni_culturali_primo_atto_sottoposto_a_condizione",
          "url": "compravendita_beni_culturali_primo_atto_sottoposto_a_condizione",
          "keywords": [
            "compravendita beni culturali",
            "compravendita di beni",
            "culturali",
            "beni culturali",
            "bene culturale",
            "bene culturale",
            "beni culturali I atto sottoposto a condizione",
            "condizione",
            "sottoposto a condizione",
            "atto",
            "i atto",
            "primo atto"
          ],
          "search": false
        },
        "2": {
          "num": "1.4.20",
          "title": "Beni culturali - II Atto - Avveramento - Soggetto Iva",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "comprevenditaDiBeniCulturaliSecondoAttoAvveramentoSoggettoIva",
          "sottocategoria": "sottocategoriaBeniCulturali",
          "action": "compravendita_beni_culturali_secondo_atto_avveramento_soggetto_iva",
          "url": "compravendita_beni_culturali_secondo_atto_avveramento_soggetto_iva",
          "keywords": [
            "compravendita beni culturali",
            "compravendita di beni",
            "culturali",
            "beni culturali",
            "bene culturale",
            "bene culturale",
            "beni culturali ii atto avveramento soggetto iva",
            "atto",
            "ii atto",
            "secondo atto",
            "avveramento",
            "sotto iva",
            "iva"
          ],
          "search": false
        },
        "3": {
          "num": "1.4.30",
          "title": "Beni culturali - II Atto - Avveramento - Registro",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "comprevenditaDiBeniCulturaliSecondoAttoAvveramentoRegistro",
          "sottocategoria": "sottocategoriaBeniCulturali",
          "action": "compravendita_beni_culturali_secondo_atto_avveramento_registro",
          "url": "compravendita_beni_culturali_secondo_atto_avveramento_registro",
          "keywords": [
            "compravendita beni culturali",
            "compravendita di beni",
            "culturali",
            "beni culturali",
            "bene culturale",
            "bene culturale",
            "beni culturali ii atto avveramento registro",
            "atto",
            "ii atto",
            "secondo atto",
            "avveramento",
            "registro"
          ],
          "search": false
        }
      }
    },
    "Mutuo": {
      "icon": mutuo_surroga,
      "visible": true,
      "dati": {
        "1": {
          "num": "1.5.10",
          "title": "Finanziamento fondiario / ipotecario",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "sottocategoria": "sottocategoriaMutuoSurroga",
          "form": "mutuoFondiarioIpotecario",
          "action": "mutuo_fondiario_ipotecario",
          "url": "mutuo_fondiario_ipotecario",
          "keywords": [
            "mutuo",
            "finanziamento fondiario ipotecario",
            "finanziamento",
            "finanziamenti",
            "fondiario",
            "ipotecario",
            "ipoteca"
          ],
          "search": false
        },
        "2": {
          "num": "1.5.20",
          "title": "Surroga",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "sottocategoria": "sottocategoriaMutuoSurroga",
          "form": "mutuoSurroga",
          "action": "mutuo_surroga",
          "url": "mutuo_surroga",
          "keywords": [
            "surroga",
            "mutuo"
          ],
          "search": false
        },
        "3": {
          "num": "1.5.30",
          "title": "Quietanza per surrogazione",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "sottocategoria": "sottocategoriaMutuoSurroga",
          "form": "quietanzaPerSurrogazione",
          "action": "quietanza_per_surrogazione",
          "url": "quietanza_per_surrogazione",
          "keywords": [
            "surroga",
            "quietanza per surrogazione",
            "quietanza",
            "surrogazione",
            "mutuo"
          ],
          "search": false
        }
      }
    },
    "Donazioni e Risoluzioni": {
      "icon": donazioni,
      "visible": true,
      "dati": {
        "1": {
          "num": "1.6.10",
          "title": "Beni immobili",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "donazioniBeniImmobili",
          "sottocategoria": "sottocategoriaDonazioniRisoluzioniAttiCostitutivi",
          "action": "donazioni_beni_immobili",
          "url": "donazioni_beni_immobili",
          "keywords": [
            "donazioni",
            "donazione",
            "donazioni e risoluzioni",
            "beni immobili",
            "beni",
            "bene",
            "immobili",
            "immobile",
            "risoluzioni",
            "risoluzione"
          ],
          "search": false
        }
      }
    },
    "Permute": {
      "icon": permute,
      "visible": true,
      "dati": {
        "1": {
          "num": "1.7.10",
          "title": "Permuta tra beni registro",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "permutaTraBeniRegistro",
          "sottocategoria": "sottocategoriaPermute",
          "action": "permuta_tra_beni_registro",
          "url": "permuta_tra_beni_registro",
          "keywords": [
            "permute",
            "permuta",
            "permuta tra beni registro",
            "beni",
            "bene",
            "bene registro",
            "beni registro",
            "registro"
          ],
          "search": false
        },
        "2": {
          "num": "1.7.20",
          "title": "Permuta tra beni iva",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "permutaTraBeniIva",
          "sottocategoria": "sottocategoriaPermute",
          "action": "permuta_tra_beni_iva",
          "url": "permuta_tra_beni_iva",
          "keywords": [
            "permute",
            "permuta",
            "permuta tra beni iva",
            "beni",
            "bene",
            "bene iva",
            "beni iva",
            "iva"
          ],
          "search": false
        }
      }
    },
    "Conferimenti": {
      "icon": conferimenti,
      "visible": true,
      "dati": {
        "1": {
          "num": "1.8.10",
          "title": "Conferimenti in società di immobili non strumentali",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "conferimentiInSocietaDiImmobiliNonStrumentali",
          "sottocategoria": "sottocategoriaConferimenti",
          "action": "conferimenti_in_societa_di_immobili_non_strumentali",
          "url": "conferimenti_in_societa_di_immobili_non_strumentali",
          "keywords": [
            "conferimenti",
            "conferimenti in società di immobili non strumentali",
            "conferimenti in società",
            "società",
            "immobili",
            "immobili non strumentali",
            "non strumentali",
            "strumentali"
          ],
          "search": false
        },
        "2": {
          "num": "1.8.20",
          "title": "Conferimenti in società di fabbricati strumentali o di aree destinate alla loro costruzione",
          "description": "",
          "disabled": false,
          "form": "conferimentiInSocietaDiFabbricatiStrumentaliDiAreeDestinateAllaLoroCostruzione",
          "categoria": "categoriaImmobiliare",
          "sottocategoria": "sottocategoriaConferimenti",
          "action": "conferimenti_in_societa_di_fabbricati_strumentali_o_di_aree_destinate_alla_loro_costruzione",
          "url": "conferimenti_in_societa_di_fabbricati_strumentali_o_di_aree_destinate_alla_loro_costruzione",
          "keywords": [
            "conferimenti",
            "conferimenti in società di fabbricati strumentali o di aree destinate alla loro costruzione",
            "conferimenti in società",
            "società",
            "fabbricati",
            "fabbricato",
            "fabbricati strumentali",
            "costruzione",
            "costruzioni",
            "aree"
          ],
          "search": false
        }
      }
    },
    "Servitu": {
      "icon": servitu,
      "visible": true,
      "dati": {
        "1": {
          "num": "1.9.10",
          "title": "Costituzione di servitù a titolo gratuito",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "costituzioneServituATitoloGratuito",
          "sottocategoria": "sottocategoriaServitu",
          "action": "costituzione_servitu_a_titolo_gratuito",
          "url": "costituzione_servitu_a_titolo_gratuito",
          "keywords": [
            "servitù",
            "costituzione di servitù a titolo gratuito",
            "costituzione",
            "titolo",
            "titolo gratuito",
            "gratuito"
          ],
          "search": false
        },
        "2": {
          "num": "1.9.20",
          "title": "Costituzione di servitù a titolo oneroso - soggetta a registro",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "costituzioneServituATitoloOnerosoSoggettaARegistro",
          "sottocategoria": "sottocategoriaServitu",
          "action": "costituzione_servitu_a_titolo_oneroso_soggetta_a_registro",
          "url": "costituzione_servitu_a_titolo_oneroso_soggetta_a_registro",
          "keywords": [
            "servitù",
            "costituzione di servitù a titolo oneroso soggetta a registro",
            "costituzione",
            "titolo",
            "titolo oneroso",
            "soggetta a registro",
            "registro"
          ],
          "search": false
        },
        "3": {
          "num": "1.9.30",
          "title": "Costituzione di servitù a titolo oneroso - soggetta a iva",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "costituzioneServituATitoloOnerosoSoggettaAIva",
          "sottocategoria": "sottocategoriaServitu",
          "action": "costituzione_servitu_a_titolo_oneroso_soggetta_a_iva",
          "url": "costituzione_servitu_a_titolo_oneroso_soggetta_a_iva",
          "keywords": [
            "servitù",
            "costituzione di servitù a titolo oneroso soggetta a iva",
            "costituzione",
            "titolo",
            "titolo oneroso",
            "iva",
            "soggetta a iva"
          ],
          "search": false
        }
      }
    },
    "Divisioni": {
      "icon": divisioni,
      "visible": true,
      "dati": {
        "1": {
          "num": "1.10.10",
          "title": "Divisione senza conguagli",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "divisioniSenzaConguagli",
          "sottocategoria": "sottocategoriaDivisioni",
          "action": "divisioni_senza_conguagli",
          "url": "divisioni_senza_conguagli",
          "keywords": [
            "divisione senza conguagli",
            "divisioni senza conguagli",
            "divisioni",
            "divisione",
            "conguagli"
          ],
          "search": false
        },
        "2": {
          "num": "1.10.20",
          "title": "Divisione con conguagli",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "divisioniConConguagli",
          "sottocategoria": "sottocategoriaDivisioni",
          "action": "divisioni_con_conguagli",
          "url": "divisioni_con_conguagli",
          "keywords": [
            "divisione con conguagli",
            "divisioni con conguagli",
            "divisioni",
            "divisione",
            "conguagli"
          ],
          "search": false
        }
      }
    },
    "Operazioni su Pregiudizievoli": {
      "icon": cancellazione_ipoteca,
      "visible": true,
      "dati": {
        "1": {
          "num": "1.11.10",
          "title": "Operazioni su ipoteche volontarie",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "operazioniIpotecheVolontarie",
          "sottocategoria": "sottocategoriaOperazioniIpoteche",
          "action": "operazioni_ipoteche_volontarie",
          "url": "operazioni_ipoteche_volontarie",
          "keywords": [
            "operazioni su pregiudizievoli",
            "operazione su pregiudizievoli",
            "operazioni",
            "pregiudizievoli",
            "operazioni su ipoteche volontarie",
            "ipoteca",
            "ipoteche",
            "volontaria",
            "volontarie"
          ],
          "search": false
        },
        "2": {
          "num": "1.11.20",
          "title": "Operazioni su ipoteche giudiziali e pignoramenti",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "form": "operazioniIpotecheGiudizialiPignoramenti",
          "sottocategoria": "sottocategoriaOperazioniIpoteche",
          "action": "operazioni_ipoteche_giudiziali_pignoramenti",
          "url": "operazioni_ipoteche_giudiziali_pignoramenti",
          "keywords": [
            "operazioni su pregiudizievoli e pignoramenti",
            "operazione su pregiudizievoli e pignoramenti",
            "operazioni",
            "pignoramento",
            "pignoramenti",
            "pregiudizievoli",
            "operazioni su ipoteche volontarie",
            "ipoteca",
            "ipoteche"
          ],
          "search": false
        }
      }
    },
    "Trasferimenti al Coniuge": {
      "icon": trasferimenti_coniuge,
      "visible": true,
      "dati": {
        "1": {
          "num": "1.12.10",
          "title": "Trasferimento immobiliare per sentenza",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "sottocategoria": "sottocategoriaTrasferimentiAlConiuge",
          "form": "trasferimentoImmobiliarePerSentenza",
          "action": "trasferimento_immobiliare_per_sentenza",
          "url": "trasferimento_immobiliare_per_sentenza",
          "keywords": [
            "trasferimenti al coniuge",
            "trasferimento",
            "coniuge",
            "trasferimento immobiliare per sentenza",
            "trasferimento immobiliare",
            "immobiliare",
            "immobili",
            "sentenza"
          ],
          "search": false
        }
      }
    },
    "Atti dichiarativi": {
      "icon": atti_dichiarativi,
      "visible": true,
      "dati": {
        "1": {
          "num": "1.13.10",
          "title": "Vincolo urbanistico edilizio",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "sottocategoria": "sottocategoriaAttiDichiarativi",
          "form": "vincoloUrbanisticoEdilizio",
          "action": "vincolo_urbanistico_edilizio",
          "url": "vincolo_urbanistico_edilizio",
          "keywords": [
            "vincolo urbanistico edilizio",
            "vincolo",
            "urbanistico",
            "immobili",
            "atti dichiarativi",
            "atti"
          ],
          "search": false
        },
        "2": {
          "num": "1.13.20",
          "title": "Convenzione per lo svincolo dal prezzo massimo di cessione",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "sottocategoria": "sottocategoriaAttiDichiarativi",
          "form": "convenzionePerLoSvincoloDalPrezzoMassimoDiCessione",
          "action": "convenzione_per_lo_svincolo_dal_prezzo_massimo_di_cessione",
          "url": "convenzione_per_lo_svincolo_dal_prezzo_massimo_di_cessione",
          "keywords": [
            "Convenzione per lo svincolo dal prezzo massimo di cessione",
            "vincolo",
            "svincolo",
            "prezzo",
            "cessione",
            "atti dichiarativi",
            "atti"
          ],
          "search": false
        },
        "3": {
          "num": "1.13.30",
          "title": "Preliminare di Vendita",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "sottocategoria": "sottocategoriaAttiDichiarativi",
          "form": "preliminareDiVendita",
          "action": "preliminare_di_vendita",
          "url": "preliminare_di_vendita",
          "keywords": [
            "preliminare di vendita",
            "vendita",
            "preliminare",
            "atti dichiarativi",
            "atti"
          ],
          "search": false
        }
      }
    },
    "Altri trasferimenti": {
      "icon": altri_trasferimenti,
      "visible": true,
      "dati": {
        "1": {
          "num": "1.14.10",
          "title": "Riscatto da Società di Leasing",
          "description": "",
          "disabled": false,
          "categoria": "categoriaImmobiliare",
          "sottocategoria": "sottocategoriaAltriTrasferimenti",
          "form": "riscattoDaSocietaDiLeasing",
          "action": "riscatto_da_societa_di_leasing",
          "url": "riscatto_da_societa_di_leasing",
          "keywords": [
            "riscatto da societa di leasing",
            "riscatto",
            "società",
            "leasing"
          ],
          "search": false
        }
      }
    }
  },
  "Societario": {
    "Costituzioni": {
      "icon": costituzione_societa,
      "visible": true,
      "dati": {
        "1": {
          "num": "2.1.10",
          "title": "Costituzione di società",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "sottocategoria": "sottocategoriaCostituzione",
          "form": "costituzioneSocieta",
          "action": "costituzione_societa",
          "url": "costituzione_societa",
          "keywords": [
            "costituzioni",
            "costituzione",
            "costituzione di società",
            "società"
          ],
          "search": false
        },
        "2": {
          "num": "2.1.20",
          "title": "Costituzione di società con conferimenti",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "sottocategoria": "sottocategoriaCostituzione",
          "form": "costituzioneSocietaConConferimenti",
          "action": "costituzione_societa_con_conferimenti",
          "url": "costituzione_societa_con_conferimenti",
          "keywords": [
            "costituzioni",
            "costituzione",
            "costituzione di società",
            "costituzione di società con conferimenti",
            "conferimento",
            "conferimenti",
            "società"
          ],
          "search": false
        }
      }
    },
    "Cessioni Quote": {
      "icon": cessione_quote,
      "visible": true,
      "dati": {
        "1": {
          "num": "2.2.10",
          "title": "Cessione di quote o partecipazioni",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "sottocategoria": "sottocategoriaCessioneQuote",
          "form": "cessioneQuote",
          "action": "cessione_quote",
          "url": "cessione_quote",
          "keywords": [
            "cessioni quote",
            "cessione quote",
            "cessione di quote o partecipazioni",
            "quote",
            "partecipazioni",
            "cessione di quote"
          ],
          "search": false
        },
        "2": {
          "num": "2.2.20",
          "title": "Recesso di socio di S.r.l. o S.p.A. mediante riduzione del capitale",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "sottocategoria": "sottocategoriaCessioneQuote",
          "form": "recessoDiSocioMedianteRiduzioneDelCapitale",
          "action": "recesso_di_socio_mediante_riduzione_del_capitale",
          "url": "recesso_di_socio_mediante_riduzione_del_capitale",
          "keywords": [
            "recesso di socio mediante riduzione del capitale",
            "recesso",
            "riduzione",
            "capitale",
            "quote",
            "cessione di quote"
          ],
          "search": false
        }
      }
    },
    "Verbali Assemblea": {
      "icon": verbale_assemblea,
      "visible": true,
      "dati": {
        "1": {
          "num": "2.3.10",
          "title": "Modifica di società",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "sottocategoria": "sottocategoriaVerbaliDiAssemblea",
          "form": "modificaSocietaria",
          "action": "verbali_assemblea_modifica_societaria",
          "url": "verbali_assemblea_modifica_societaria",
          "keywords": [
            "verbali assemblea",
            "verbale assemblea",
            "modifica di società",
            "modifica di società",
            "modifica",
            "società",
            "assemblea"
          ],
          "search": false
        }
      }
    },
    "Scioglimenti Società": {
      "icon": cessione_quote,
      "visible": true,
      "dati": {
        "1": {
          "num": "2.4.10",
          "title": "Scioglimento di società",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "sottocategoria": "sottocategoriaScioglimentoSocieta",
          "form": "scioglimentoSocietaConSenzaImmobili",
          "action": "scioglimento_societa_con_senza_immobili",
          "url": "scioglimento_societa_con_senza_immobili",
          "keywords": [
            "scioglimenti società",
            "scioglimento società",
            "scioglimenti societa",
            "scioglimento di società",
            "società",
            "scioglimento"
          ],
          "search": false
        }
      }
    },
    "Cessioni Aziende": {
      "icon": cessione_aziende,
      "visible": true,
      "dati": {
        "1": {
          "num": "2.5.10",
          "title": "Cessione di azienda - senza immobili",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "sottocategoria": "sottocategoriaCessioneAziende",
          "form": "cessioneAziendeSenzaImmobili",
          "action": "cessione_aziende_senza_immobili",
          "url": "cessione_aziende_senza_immobili",
          "keywords": [
            "cessioni aziende",
            "cessione azienda",
            "cessioni",
            "cessione",
            "azienda",
            "aziende",
            "cessione di azienda con immobili",
            "senza immobili",
            "immobili"
          ],
          "search": false
        },
        "2": {
          "num": "2.5.20",
          "title": "Cessione di azienda - con immobili",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "sottocategoria": "sottocategoriaCessioneAziende",
          "form": "cessioneAziendeConImmobili",
          "action": "cessione_aziende_con_immobili",
          "url": "cessione_aziende_con_immobili",
          "keywords": [
            "cessioni aziende",
            "cessione azienda",
            "cessioni",
            "cessione",
            "azienda",
            "aziende",
            "cessione di azienda con immobili",
            "con immobili",
            "immobili"
          ],
          "search": false
        }
      }
    },
    "Affitto di Aziende": {
      "icon": affitto_azienda,
      "visible": true,
      "dati": {
        "1": {
          "num": "2.6.10",
          "title": "Affitto di azienda - con / senza immobili",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "sottocategoria": "sottocategoriaAffittoAzienda",
          "form": "affittoAziendaConSenzaImmobili",
          "action": "affitto_azienda_con_senza_immobili",
          "url": "affitto_azienda_con_senza_immobili",
          "keywords": [
            "affitto",
            "aziende",
            "affitto azienda",
            "affitto di aziende",
            "affitto di azienda con o senza immobili",
            "senza immobili",
            "con immobili",
            "immobili"
          ],
          "search": false
        },
        "2": {
          "num": "2.6.20",
          "title": "Affitto ramo di azienda compresi immobili",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "sottocategoria": "sottocategoriaAffittoAzienda",
          "form": "affittoRamoDiAziendaConImmobiliSupera50NonSupera50",
          "action": "affitto_ramo_azienda_con_immobili_supera_50_non_supera_50",
          "url": "affitto_ramo_azienda_con_immobili_supera_50_non_supera_50",
          "keywords": [
            "affitto di aziende",
            "affitto",
            "affitto ramo di azienda compresi immobili",
            "ramo di azienda",
            "immobili"
          ],
          "search": false
        },
        "3": {
          "num": "2.6.30",
          "title": "Proroga di affitto di azienda",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "sottocategoria": "sottocategoriaAffittoAzienda",
          "form": "prorogaDiAffittoDiAzienda",
          "action": "proroga_di_affitto_di_azienda",
          "url": "proroga_di_affitto_di_azienda",
          "keywords": [
            "proroga di affitto di azienda",
            "affitto di aziende",
            "affitto",
            "proroga"
          ],
          "search": false
        },
        "4": {
          "num": "2.6.40",
          "title": "Risoluzione di affitto di azienda",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "sottocategoria": "sottocategoriaAffittoAzienda",
          "form": "risoluzioneDiAffittoDiAzienda",
          "action": "risoluzione_di_affitto_di_azienda",
          "url": "risoluzione_di_affitto_di_azienda",
          "keywords": [
            "risoluzione di affitto di azienda",
            "affitto di aziende",
            "affitto",
            "risoluzione"
          ],
          "search": false
        }
      }
    },
    "Donazioni e Risoluzioni": {
      "icon": donazioni,
      "visible": true,
      "dati": {
        "1": {
          "num": "2.7.10",
          "title": "Donazione di denaro o altri titoli, azioni, obbligazioni",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "form": "donazioniDenaroAltriTitoliAzioniObbligazioni",
          "sottocategoria": "sottocategoriaDonazioniRisoluzioniAttiCostitutivi",
          "action": "donazioni_denaro_altri_titoli_azioni_obbligazioni",
          "url": "donazioni_denaro_altri_titoli_azioni_obbligazioni",
          "keywords": [
            "azioni",
            "azioni obbligazioni",
            "titoli",
            "titoli azioni",
            "donazione",
            "donazioni",
            "donazione di denaro",
            "donazione di denaro o altri titoli azioni obbligazioni",
            "obbligazioni"
          ],
          "search": false
        },
        "2": {
          "num": "2.7.20",
          "title": "Donazione di partecipazioni sociali e aziende",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "form": "donazioniPartecipazioniSocialiAziende",
          "sottocategoria": "sottocategoriaDonazioniRisoluzioniAttiCostitutivi",
          "action": "donazioni_partecipazioni_sociali_aziende",
          "url": "donazioni_partecipazioni_sociali_aziende",
          "keywords": [
            "donazioni e risoluzioni",
            "donazioni risoluzioni",
            "risoluzioni",
            "donazione",
            "risoluzione",
            "donazione di partecipazioni sociali e aziende",
            "partecipazioni",
            "sociali",
            "aziende"
          ],
          "search": false
        }
      }
    },
    "Vidimazioni": {
      "icon": procura,
      "visible": true,
      "dati": {
        "1": {
          "num": "2.8.10",
          "title": "Vidimazione libri sociali",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "form": "vidimazioniLibriSociali",
          "sottocategoria": "sottocategoriaVidimazioni",
          "action": "vidimazioni_libri_sociali",
          "url": "vidimazioni_libri_sociali",
          "keywords": [
            "societario",
            "società",
            "vidimazione libri sociali",
            "vidimazioni",
            "libri",
            "sociale",
            "sociali",
            "vidimazioni libri"
          ],
          "search": false
        }
      }
    },
    "Atti vari": {
      "icon": atti_vari,
      "visible": true,
      "dati": {
        "1": {
          "num": "2.9.10",
          "title": "Raggruppamento temporaneo di imprese",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "form": "raggruppamentoTemporaneoDiImprese",
          "sottocategoria": "sottocategoriaAttiVari",
          "action": "raggruppamento_temporaneo_di_imprese",
          "url": "raggruppamento_temporaneo_di_imprese",
          "keywords": [
            "raggruppamento temporaneo di imprese",
            "raggruppamento",
            "temporaneo",
            "imprese"
          ],
          "search": false
        }
      }
    },
    "Scissioni e Fusioni": {
      "icon": scissioni_fusioni,
      "visible": true,
      "dati": {
        "1": {
          "num": "2.10.10",
          "title": "Delibera di Scissione - società scindenda",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "form": "deliberaDiScissioneSocietaScindenda",
          "sottocategoria": "sottocategoriaScissioniFusioni",
          "action": "delibera_di_scissione_societa_scindenda",
          "url": "delibera_di_scissione_societa_scindenda",
          "keywords": [
            "delibera di scissione societa scindenda",
            "delibera",
            "scissione",
            "scindenda",
            "società"
          ],
          "search": false
        },
        "2": {
          "num": "2.10.20",
          "title": "Delibera di Scissione - società scissionaria",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "form": "deliberaDiScissioneSocietaScissionaria",
          "sottocategoria": "sottocategoriaScissioniFusioni",
          "action": "delibera_di_scissione_societa_scissionaria",
          "url": "delibera_di_scissione_societa_scissionaria",
          "keywords": [
            "delibera di scissione societa scissionaria",
            "delibera",
            "scissione",
            "scissionaria",
            "società"
          ],
          "search": false
        },
        "3": {
          "num": "2.10.30",
          "title": "Atto di Scissione",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "form": "attoDiScissione",
          "sottocategoria": "sottocategoriaScissioniFusioni",
          "action": "atto_di_scissione",
          "url": "atto_di_scissione",
          "keywords": [
            "atto di scissione",
            "scissione",
            "atto",
            "società"
          ],
          "search": false
        },
        "4": {
          "num": "2.10.40",
          "title": "Delibera di Fusione - società incorporanda",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "form": "deliberaDiFusioneSocietaIncorporanda",
          "sottocategoria": "sottocategoriaScissioniFusioni",
          "action": "delibera_di_fusione_societa_incorporanda",
          "url": "delibera_di_fusione_societa_incorporanda",
          "keywords": [
            "delibera di fusione società incorporanda",
            "delibera",
            "fusione",
            "incorporanda",
            "società"
          ],
          "search": false
        },
        "5": {
          "num": "2.10.50",
          "title": "Delibera di Fusione - società incorporante",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "form": "deliberaDiFusioneSocietaIncorporante",
          "sottocategoria": "sottocategoriaScissioniFusioni",
          "action": "delibera_di_fusione_societa_incorporante",
          "url": "delibera_di_fusione_societa_incorporante",
          "keywords": [
            "delibera di fusione società incorporante",
            "delibera",
            "fusione",
            "incorporanda",
            "società"
          ],
          "search": false
        },
        "6": {
          "num": "2.10.60",
          "title": "Atto di Fusione",
          "description": "",
          "disabled": false,
          "categoria": "categoriaSocietario",
          "form": "attoDiFusione",
          "sottocategoria": "sottocategoriaScissioniFusioni",
          "action": "atto_di_fusione",
          "url": "atto_di_fusione",
          "keywords": [
            "atto di fusione",
            "atto",
            "fusione",
            "società"
          ],
          "search": false
        }
      }
    },
  },
  "Famiglia": {
    "Separazioni": {
      "icon": separazione,
      "visible": true,
      "dati": {
        "1": {
          "num": "3.1.10",
          "title": "Separazione dei beni",
          "description": "",
          "disabled": false,
          "categoria": "categoriaFamiglia",
          "sottocategoria": "sottocategoriaSeparazione",
          "form": "separazioneDeiBeni",
          "action": "separazione_dei_beni",
          "url": "separazione_dei_beni",
          "keywords": [
            "separazioni",
            "separazione",
            "separazione dei beni",
            "beni",
            "bene",
            "famiglia",
            "separazione beni"
          ],
          "search": false
        },
        "2": {
          "num": "3.1.20",
          "title": "Comunione dei beni",
          "description": "",
          "disabled": false,
          "categoria": "categoriaFamiglia",
          "sottocategoria": "sottocategoriaSeparazione",
          "form": "comunioneDeiBeni",
          "action": "comunione_dei_beni",
          "url": "comunione_dei_beni",
          "keywords": [
            "separazioni",
            "separazione",
            "comunione dei beni",
            "comunione",
            "beni",
            "bene",
            "famiglia"
          ],
          "search": false
        },
        "3": {
          "num": "3.1.30",
          "title": "Trasferimento immobiliare per sentenza",
          "description": "",
          "disabled": false,
          "categoria": "categoriaFamiglia",
          "sottocategoria": "sottocategoriaSeparazione",
          "form": "trasferimentoImmobiliarePerSentenza",
          "action": "trasferimento_immobiliare_per_sentenza",
          "url": "trasferimento_immobiliare_per_sentenza",
          "keywords": [
            "separazioni",
            "separazione",
            "trasferimento immobiliare per sentenza",
            "trasferimento",
            "famiglia",
            "immobiliare",
            "sentenza"
          ],
          "search": false
        }
      }
    },
    "Fondo patrimoniale": {
      "icon": fondo_patrimoniale,
      "visible": true,
      "dati": {
        "1": {
          "num": "3.2.10",
          "title": "Costituzione del fondo patrimoniale",
          "description": "",
          "disabled": false,
          "categoria": "categoriaFamiglia",
          "form": "costituzioneFondoPatrimoniale",
          "sottocategoria": "sottocategoriaFondoPatrimoniale",
          "action": "costituzione_del_fondo_patrimoniale",
          "url": "costituzione_del_fondo_patrimoniale",
          "keywords": [
            "fondo patrimoniale",
            "costituzione del fondo patrimoniale",
            "costituzione",
            "fondo",
            "famiglia",
            "patrimoniale",
            "costituzione fondo"
          ],
          "search": false
        }
      }
    }
  },
  "AttiMortisCausa": {
    "Atti mortis causa": {
      "icon": atti_mortis_causa,
      "visible": true,
      "dati": {
        "1": {
          "num": "4.1.10",
          "title": "Accettazione eredità",
          "description": "",
          "disabled": false,
          "categoria": "categoriaAttiMortisCausa",
          "form": "accettazioneEredita",
          "sottocategoria": "sottocategoriaAttiMortisCausa",
          "action": "accettazione_eredita",
          "url": "accettazione_eredita",
          "keywords": [
            "atti mortis causa",
            "atti",
            "mortis",
            "causa",
            "accettazione eredità",
            "accettazione",
            "eredità",
            "testamento",
            "eredita"
          ],
          "search": false
        },
        "2": {
          "num": "4.1.20",
          "title": "Rinuncia eredità",
          "description": "",
          "disabled": false,
          "categoria": "categoriaAttiMortisCausa",
          "form": "rinunciaEredita",
          "sottocategoria": "sottocategoriaAttiMortisCausa",
          "action": "rinuncia_eredita",
          "url": "rinuncia_eredita",
          "keywords": [
            "atti mortis causa",
            "atti",
            "mortis",
            "causa",
            "rinuncia eredità",
            "rinuncia",
            "eredità",
            "testamento",
            "eredita"
          ],
          "search": false
        },
        "3": {
          "num": "4.1.30",
          "title": "Pubblicazione testamento olografo",
          "description": "",
          "disabled": false,
          "categoria": "categoriaAttiMortisCausa",
          "form": "pubblicazioneTestamentoOlografo",
          "sottocategoria": "sottocategoriaAttiMortisCausa",
          "action": "pubblicazione_testamento_olografo",
          "url": "pubblicazione_testamento_olografo",
          "keywords": [
            "atti mortis causa",
            "atti",
            "mortis",
            "causa",
            "pubblicazione testamento olografo",
            "pubblicazione",
            "testamento",
            "olografo"
          ],
          "search": false
        },
        "4": {
          "num": "4.1.40",
          "title": "Passaggio agli atti tra vivi di testamento pubblico",
          "description": "",
          "disabled": false,
          "categoria": "categoriaAttiMortisCausa",
          "form": "passaggioAgliAttiTraViviDiTestamentoPubblico",
          "sottocategoria": "sottocategoriaAttiMortisCausa",
          "action": "passaggio_agli_atti_tra_vivi_di_testamento_pubblico",
          "url": "passaggio_agli_atti_tra_vivi_di_testamento_pubblico",
          "keywords": [
            "atti mortis causa",
            "atti",
            "mortis",
            "causa",
            "passaggio agli atti tra vivi di testamento pubblico",
            "passaggio",
            "atti",
            "vivi",
            "testamento",
            "testamento pubblico"
          ],
          "search": false
        }
      }
    }
  },
  "Altro": {
    "Procure": {
      "icon": procedure,
      "visible": true,
      "dati": {
        "1": {
          "num": "5.1.10",
          "title": "Procura speciale rilasciata",
          "description": "",
          "disabled": false,
          "categoria": "categoriaAltro",
          "form": "procuraSpecialeRilasciata",
          "sottocategoria": "sottocategoriaProcure",
          "action": "procura_speciale_rilasciata",
          "url": "procura_speciale_rilasciata",
          "keywords": [
            "procure",
            "procura",
            "procura speciale",
            "rilasciata",
            "speciale"
          ],
          "search": false
        },
        "2": {
          "num": "5.1.20",
          "title": "Procura generale",
          "description": "",
          "disabled": false,
          "categoria": "categoriaAltro",
          "form": "procuraGenerale",
          "sottocategoria": "sottocategoriaProcure",
          "action": "procura_generale",
          "url": "procura_generale",
          "keywords": [
            "procure",
            "procura",
            "procura generale"
          ],
          "search": false
        },
        "3": {
          "num": "5.1.30",
          "title": "Revoca di procura",
          "description": "",
          "disabled": false,
          "categoria": "categoriaAltro",
          "form": "revocaDiProcura",
          "sottocategoria": "sottocategoriaProcure",
          "action": "revoca_di_procura",
          "url": "revoca_di_procura",
          "keywords": [
            "procure",
            "procura",
            "revoca di procura"
          ],
          "search": false
        }
      }
    },
    "Accettazione tacita": {
      "icon": accettazione_tacita,
      "visible": true,
      "dati": {
        "1": {
          "num": "5.2.10",
          "title": "Accettazione tacita eredità",
          "description": "",
          "disabled": false,
          "categoria": "categoriaAltro",
          "form": "accettazioneTacitaEredita",
          "sottocategoria": "sottocategoriaAccettazioneTacita",
          "action": "accettazione_tacita_eredita",
          "url": "accettazione_tacita_eredita",
          "keywords": [
            "accettazione",
            "tacita",
            "eredità"
          ],
          "search": false
        }
      }
    },
    "Estratti": {
      "icon": estratti,
      "visible": true,
      "dati": {
        "1": {
          "num": "5.3.10",
          "title": "Estratto da libri",
          "description": "",
          "disabled": false,
          "categoria": "categoriaAltro",
          "form": "estrattoDaLibri",
          "sottocategoria": "sottocategoriaEstratti",
          "action": "estratto_da_libri",
          "url": "estratto_da_libri",
          "keywords": [
            "estratti",
            "estratto",
            "libri",
            "estratto da libri"
          ],
          "search": false
        }
      }
    },
    "Certificazioni": {
      "icon": certificazioni,
      "visible": true,
      "dati": {
        "1": {
          "num": "5.4.10",
          "title": "Relazione Notarile Ventennale ex art. 567",
          "description": "",
          "disabled": false,
          "categoria": "categoriaAltro",
          "form": "relazioneVentennale",
          "sottocategoria": "sottocategoriaCertificazioni",
          "action": "relazione_ventennale",
          "url": "relazione_ventennale",
          "keywords": [
            "certificazioni",
            "relazione",
            "relazione ventennale",
            "ventennale"
          ],
          "search": false
        },
        "2": {
          "num": "5.4.20",
          "title": "Asseverazione",
          "description": "",
          "disabled": false,
          "categoria": "categoriaAltro",
          "form": "giuramento",
          "sottocategoria": "sottocategoriaCertificazioni",
          "action": "giuramento",
          "url": "giuramento",
          "keywords": [
            "certificazioni",
            "asseverazione"
          ],
          "search": false
        }
      }
    },
    "Enti del Terzo Settore e altri Enti del Libro Primo C.C.": {
      "icon": enti_terzo_settore,
      "visible": true,
      "dati": {
        "1": {
          "num": "5.5.10",
          "title": "Costituzione enti del primo libro del codice civile",
          "description": "",
          "disabled": false,
          "categoria": "categoriaAltro",
          "form": "costituzioneEntiDelPrimoLibroDelCodiceCivile",
          "sottocategoria": "sottocategoriaEntiDelterzoSettoreAltriEntiDelLibroPrimoCC",
          "action": "costituzione_enti_del_primo_libro_del_codice_civile",
          "url": "costituzione_enti_del_primo_libro_del_codice_civile",
          "keywords": [
            "costituzione enti del terzo settore",
            "terzo settore",
            "codice civile",
            "enti"
          ],
          "search": false
        },
        "2": {
          "num": "5.5.20",
          "title": "Costituzione enti del terzo settore",
          "description": "",
          "disabled": false,
          "categoria": "categoriaAltro",
          "form": "costituzioneEntiDelTerzoSettore",
          "sottocategoria": "sottocategoriaEntiDelterzoSettoreAltriEntiDelLibroPrimoCC",
          "action": "costituzione_enti_del_terzo_settore",
          "url": "costituzione_enti_del_terzo_settore",
          "keywords": [
            "costituzione enti del terzo settore",
            "terzo settore",
            "codice civile"
          ],
          "search": false
        }
      }
    },
    "Vari": {
      "icon": vari,
      "visible": true,
      "dati": {
        "1": {
          "num": "5.6.10",
          "title": "Cessioni di Crediti",
          "description": "",
          "disabled": false,
          "categoria": "categoriaAltro",
          "form": "cessioniDiCrediti",
          "sottocategoria": "sottocategoriaVari",
          "action": "cessioni_di_crediti",
          "url": "cessioni_di_crediti",
          "keywords": [
            "cessioni di credito",
            "cessioni",
            "crediti",
            "altro",
            "vari"
          ],
          "search": false
        },
        "2": {
          "num": "5.6.20",
          "title": "Donazione tra enti pubblici",
          "description": "",
          "disabled": false,
          "categoria": "categoriaAltro",
          "form": "donazioneTraEntiPubblici",
          "sottocategoria": "sottocategoriaVari",
          "action": "donazioni_enti_pubblici",
          "url": "donazioni_enti_pubblici",
          "keywords": [
            "Donazione tra enti pubblici",
            "ente",
            "enti",
            "donazione",
            "pubblici",
            "pubblico",
            "altro"
          ],
          "search": false
        }
      }
    }
  }
}